import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Checkbox, Typography } from "@mui/material";
import LogoSvg from "../../atoms/LogoSvg/LogoSvg";
import SantevetLogo from "../../../assets/santevet.svg";
import { QuestionProps } from "../../../types/components/molecules/questionProps";

const Twelfth = ({ formData, setFormData, onValidationChange }: QuestionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    // This step is always valid (opt-in is optional)
    onValidationChange?.(true);
  }, [onValidationChange]);

  const handleCheckboxChange = () => {
    setFormData({
      ...formData,
      santevet_optin: !formData.santevet_optin,
    });
  };

  const animalName = formData.name || "";
  const description = t("animalInfo:santevet.description", {
    animal_name: animalName,
  });

  return (
    <Box className="santevetBox" onClick={handleCheckboxChange}>
      <Box className="santevetBanner">
        <Box className="santevetBannerLogo">
          <LogoSvg src={SantevetLogo} className="santevetBannerLogoImg" />
        </Box>
        <Typography variant="h6" className="santevetBannerTitle">
          {t("animalInfo:santevet.title")}
        </Typography>
      </Box>
      <Box className="santevetContent">
        <Typography variant="body1" className="santevetDescription">
          {description}
        </Typography>
        <Box className="santevetCheckboxContainer">
          <Checkbox
            checked={formData.santevet_optin || false}
            className="santevetCheckbox"
            readOnly
          />
          <Typography 
            variant="body1" 
            className="santevetOptinText"
          >
            {t("animalInfo:santevet.optin").replace('🎁', '')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Twelfth;

